import {createContext} from "react";
export const SubjectsContext = createContext(null);

const SubjectsProvider = ({ children, subjects, onSave }) => {
 return (
     <SubjectsContext.Provider value={{ subjects, onSave }}>
         {children}
     </SubjectsContext.Provider>
 );
};

export default SubjectsProvider;
